import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    FaMapMarkerAlt, FaRedo, FaStoreAlt, FaLocationArrow,
    FaAngleLeft, FaExclamationTriangle, FaSpinner, FaShieldAlt, FaSearch, FaTimesCircle
} from "react-icons/fa";
import PublicBackMethods from "./PublicBackMethods";

const NearbyEstablishments = () => {
    const { public_request } = PublicBackMethods();

    const navigate = useNavigate();
    const [position, setPosition] = useState({ lat: null, lng: null });
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [establishments, setEstablishments] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const getLocation = () => {
        setLoading(true);
        setError(null);
        if (!navigator.geolocation) {
            setError("المتصفح لا يدعم تحديد الموقع الجغرافي");
            setLoading(false);
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (pos) => {
                const coords = { lat: pos.coords.latitude, lng: pos.coords.longitude };
                setPosition(coords);
                fetchNearbyData(coords.lat, coords.lng);
            },
            (err) => {
                console.log(err)
                setLoading(false);
                if (err.code === 1) setError("يرجى منح صلاحية الوصول للموقع من إعدادات المتصفح");
                else setError("تعذر تحديد موقعك، تأكد من تفعيل الـ GPS");
            },
            { enableHighAccuracy: true, timeout: 10000 }
        );
    };

    const fetchNearbyData = async (lat, lng) => {
        try {
            const response = await public_request.post('/public/establishments/nearby', {
                lat, lng
            });
            const data = response.data;
            setEstablishments(data.establishments || []);
        } catch (err) {
            console.log(err)

            setError("فشل الاتصال بالخادم لجلب البيانات");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { getLocation(); }, []);

    // تصفية النتائج
    const filteredEstablishments = establishments.filter(item =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.city.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="main-wrapper pb-5" dir="rtl">
            <header className="container pt-5 text-center mb-4">
                <div className="gov-badge mb-3 animate-fade-in">
                    <FaShieldAlt className="ms-2 text-warning" />
                    الادارة العامة للتجارة الداخلية وحماية المستهلك
                </div>
                <h2 className="fw-bold text-white animate-fade-in header-title">الفعاليات التجارية المحيطة</h2>
            </header>

            <div className="container">
                {/* شرط ظهور مربع البحث: 
                   1. لا يوجد تحميل (loading === false)
                   2. لا يوجد خطأ (error === null)
                   3. توجد بيانات في المصفوفة الأصلية القادمة من السيرفر
                */}
                {!loading && !error && establishments.length > 0 && (
                    <div className="row justify-content-center mb-5 animate-fade-in">
                        <div className="col-md-8 col-lg-6">
                            <div className={`premium-search-box ${searchTerm ? 'active-glow' : ''}`}>
                                <div className="input-group align-items-center px-3">
                                    <FaSearch className={searchTerm ? 'text-info' : 'text-white-50'} />
                                    <input
                                        type="text"
                                        className="form-control search-input"
                                        placeholder="ابحث ضمن النتائج..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                    {searchTerm && (
                                        <FaTimesCircle
                                            className="clear-icon"
                                            onClick={() => setSearchTerm("")}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* حالة التحميل */}
                {loading && (
                    <div className="text-center py-5">
                        <div className="spinner-border text-info mb-3" role="status"></div>
                        <p className="text-info fw-bold">جاري تحديد الموقع الجغرافي...</p>
                    </div>
                )}

                {/* حالة الخطأ */}
                {error && (
                    <div className="text-center py-4 bg-danger bg-opacity-10 rounded-4 border border-danger border-opacity-25 mx-auto" style={{ maxWidth: '500px' }}>
                        <FaExclamationTriangle className="text-danger mb-2" size={30} />
                        <p className="text-white small px-3">{error}</p>
                        <button className="btn btn-outline-danger btn-sm rounded-pill px-4" onClick={() => window.location.reload()}>تحديث</button>
                    </div>
                )}

                {/* عرض الكروت */}
                {!loading && filteredEstablishments.length > 0 && (
                    <div className="row g-4 row-cols-1 row-cols-md-2 row-cols-lg-3">
                        {filteredEstablishments.map((item, index) => (
                            <div key={index} className="col animate-fade-in">
                                <div
                                    className="card h-100 dark-square-card shadow"
                                    onClick={() => navigate(`/${item.fieldUID}`)}
                                >
                                    <div className="card-body p-4 text-center">
                                        <div className="square-icon-box mx-auto mb-3">
                                            <FaStoreAlt />
                                        </div>
                                        <h5 className="card-title fw-bold text-white mb-2">{item.name}</h5>
                                        <div className="location-info mb-3">
                                            <span className="text-white-50 small d-block mb-1">{item.governorate} - {item.city}</span>
                                            <span className="badge bg-info bg-opacity-10 text-info fw-normal">
                                                <FaLocationArrow className="ms-1" size={10} />
                                                تبعد {Math.round(item.distanceMeters)} متر
                                            </span>
                                        </div>
                                        <div className="pt-3 border-top border-white border-opacity-10">
                                            <small className="text-info fw-bold">التفاصيل <FaAngleLeft /></small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* في حال تم البحث ولم تظهر نتائج فرعية */}
                {!loading && filteredEstablishments.length === 0 && searchTerm && (
                    <div className="text-center py-5 text-white-50">
                        <p>عذراً، لا توجد نتائج تطابق بحثك الحالي ضمن هذه المنطقة</p>
                    </div>
                )}
            </div>

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;900&display=swap');
                
                .main-wrapper { background: #0f172a; min-height: 100vh; font-family: 'Cairo', sans-serif; color: white; }
                .gov-badge { 
                    display: inline-flex; align-items: center; 
                    background: rgba(255, 255, 255, 0.03); color: #38bdf8; 
                    padding: 8px 20px; border-radius: 100px; font-size: 0.85rem; 
                    border: 1px solid rgba(56, 189, 248, 0.2);
                }
                .header-title { font-size: 2rem; }

                .premium-search-box {
                    background: rgba(30, 41, 59, 0.7);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 20px;
                    padding: 5px;
                    transition: all 0.4s ease;
                    backdrop-filter: blur(10px);
                }
                .premium-search-box:focus-within {
                    border-color: #0ea5e9;
                    box-shadow: 0 0 20px rgba(14, 165, 233, 0.15);
                }
                .active-glow { border-color: #0ea5e9; }

                .search-input {
                    background: transparent !important;
                    border: none !important;
                    color: white !important;
                    box-shadow: none !important;
                    padding: 12px 15px;
                }
                .search-input::placeholder { color: rgba(255, 255, 255, 0.3); }

                .clear-icon { color: rgba(255, 255, 255, 0.3); cursor: pointer; }

                .dark-square-card { 
                    background: #1e293b; border: 1px solid rgba(255, 255, 255, 0.05); 
                    border-radius: 28px; cursor: pointer; transition: 0.3s ease; 
                }
                .dark-square-card:hover { 
                    transform: translateY(-10px); background: #243147;
                    border-color: rgba(56, 189, 248, 0.3);
                }

                .square-icon-box { 
                    width: 65px; height: 65px; 
                    background: linear-gradient(135deg, #0ea5e9 0%, #2563eb 100%);
                    border-radius: 20px; display: flex; justify-content: center; align-items: center; 
                    color: white; font-size: 1.8rem;
                }

                .animate-fade-in { animation: fadeIn 0.5s ease-out backwards; }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>
        </div>
    );
};

export default NearbyEstablishments;